import { colourByName, doorRules, productRowSchema, productsFeed, } from '@planner/config';
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function parseDoorCatalogue(value, regionCode) {
    if (!isRecord(value) || value.feed !== productsFeed.name || value.region !== regionCode) {
        throw new Error('Product feed or region is invalid');
    }
    if (typeof value.syncedAt !== 'string' ||
        !Number.isFinite(Date.parse(value.syncedAt)) ||
        !Number.isSafeInteger(value.rowCount) ||
        !Array.isArray(value.rows) ||
        value.rowCount !== value.rows.length) {
        throw new Error('Product feed envelope is invalid');
    }
    const rows = value.rows.map((row, index) => {
        if (!isRecord(row) ||
            typeof row.Active !== 'boolean' ||
            typeof row.itemStatus !== 'string' ||
            row.Active !== (row.itemStatus === 'Active') ||
            typeof row.retailPrice !== 'number' ||
            !Number.isFinite(row.retailPrice) ||
            !isRecord(row.metaData) ||
            !['minDoorWidth', 'maxDoorWidth', 'minDoorHeight', 'maxDoorHeight'].every((key) => typeof row[key] === 'number' &&
                Number.isSafeInteger(row[key]) &&
                (!row.Active || row[key] > 0))) {
            throw new Error(`Product feed row ${index + 1} is invalid`);
        }
        const parsed = productRowSchema.safeParse(row);
        if (!parsed.success ||
            parsed.data.doorType !== row.doorType ||
            parsed.data.inventoryID !== row.inventoryID ||
            parsed.data.description !== row.description ||
            parsed.data.frameColour !== row.frameColour) {
            throw new Error(`Product feed row ${index + 1} is invalid`);
        }
        return parsed.data;
    });
    return {
        feed: productsFeed.name,
        region: regionCode,
        syncedAt: value.syncedAt,
        rowCount: rows.length,
        rows,
    };
}
export function doorSnapshotFromProduct(product, syncedAt) {
    const colour = colourByName(product.frameColour);
    return {
        sku: product.inventoryID,
        description: product.description,
        unitPrice: product.retailPrice,
        colourName: colour.name,
        colourHex: colour.hex,
        imageId: product.metaData.colorSelection.imageCdnId,
        bunningsItemNumber: product.bunningsItemNumber,
        lockHeightMin: doorRules.lockHeight.min,
        lockHeightMax: doorRules.lockHeight.max,
        catalogueSyncedAt: syncedAt,
    };
}
export function resolveDoorProduct(rows, type, colour, size) {
    const matches = rows.filter((row) => row.Active &&
        row.doorType === type &&
        row.frameColour === colour &&
        sizeBandContains(row, size));
    if (matches.length > 1) {
        return { status: 'ambiguous' };
    }
    const product = matches[0];
    if (!product) {
        return { status: 'unavailable' };
    }
    if (!Number.isFinite(product.retailPrice) || product.retailPrice <= 0) {
        return { status: 'unpriced' };
    }
    return { status: 'available', product };
}
export function activeSizeBands(rows, type) {
    return rows.filter((row) => row.Active && row.doorType === type);
}
export function sizeBandContains(band, size) {
    return (size.width >= band.minDoorWidth &&
        size.width <= band.maxDoorWidth &&
        size.height >= band.minDoorHeight &&
        size.height <= band.maxDoorHeight);
}
export function sizeBandEnvelope(rows) {
    if (rows.length === 0) {
        return undefined;
    }
    return {
        minWidth: Math.min(...rows.map((row) => row.minDoorWidth)),
        maxWidth: Math.max(...rows.map((row) => row.maxDoorWidth)),
        minHeight: Math.min(...rows.map((row) => row.minDoorHeight)),
        maxHeight: Math.max(...rows.map((row) => row.maxDoorHeight)),
    };
}
export function findSizeAvailability(rows, type, size) {
    if (!Number.isSafeInteger(size.width) || !Number.isSafeInteger(size.height)) {
        return { status: 'invalid' };
    }
    const active = activeSizeBands(rows, type);
    const limits = sizeBandEnvelope(active);
    if (!limits) {
        return { status: 'empty' };
    }
    if (active.some((band) => sizeBandContains(band, size))) {
        return { status: 'available', limits };
    }
    const outside = size.width < limits.minWidth ||
        size.width > limits.maxWidth ||
        size.height < limits.minHeight ||
        size.height > limits.maxHeight;
    return { status: outside ? 'outside-range' : 'gap', limits };
}
//# sourceMappingURL=catalogue.js.map